
function initCartDiscountForm() {
  const discountCodeForms = document.querySelectorAll('#cart-discount-form');
  const normalize = (s) => (s ?? '').trim().toLowerCase();

  discountCodeForms.forEach((form) => {
    // Prevent double initialization
    if (form.dataset.discountInit === 'true') return;
    form.dataset.discountInit = 'true';

    const applyBtn = form.querySelector('#apply-discount-btn');
    if (applyBtn) applyBtn.disabled = false;
    /* ─────────────── DOM refs ─────────────── */
    const discountCodeInput   = form.parentNode.querySelector('#discount-code-input');
    const discountCodeSuccess = form.parentNode.querySelector('#discount-code-success');
    const discountCodeError   = form.parentNode.querySelector('#discount-code-error');

    /* ─────────────── UI helpers ─────────────── */
    const hideMessages = () => {
      if (discountCodeSuccess) discountCodeSuccess.style.display = 'none';
      if (discountCodeError)   discountCodeError.style.display   = 'none';
    };
    const showError   = (m) =>
      discountCodeError &&
      (discountCodeError.textContent = m,
       discountCodeError.style.display = 'block',
       setTimeout(() => (discountCodeError.style.display = 'none'), 1500));
    const showSuccess = (m) =>
      discountCodeSuccess &&
      (discountCodeSuccess.textContent = m,
       discountCodeSuccess.style.display = 'block');

    /* ─────────── verify discount helper ─────────── */
    const checkForDiscount = (cart, rawCode) => {
      const codeNorm = normalize(rawCode);
      return (
        cart.cart_level_discount_applications?.some(
          (d) => normalize(d.code || d.title) === codeNorm
        ) ||
        cart.items?.some((item) =>
          item.discounts?.some(
            (disc) => normalize(disc.code || disc.title) === codeNorm
          )
        )
      );
    };

    /* ─────────── unified, async submit ─────────── */
    form.onsubmit = async (e) => {
      e.preventDefault();
      hideMessages();

      const rawCode = discountCodeInput?.value ?? '';
      const trimmed = rawCode.trim();
      if (!trimmed) return showError('Enter a discount code');

      const codeForURL = encodeURIComponent(trimmed.toUpperCase()); // force uppercase
      showSuccess('Checking Discount…');

      try {
        // 1️⃣ apply discount silently
        await fetch(`/discount/${codeForURL}?redirect=/cart`);

        // 2️⃣ confirm it stuck
        const cartRes = await fetch('/cart.js');
        const cart    = await cartRes.json();

        if (checkForDiscount(cart, trimmed)) {
          showSuccess('Discount applied! Updating Cart…');
          setTimeout(() => window.location.href = '/cart', 2500); // redirect to cart page
        } else {
          discountCodeSuccess.style.display = 'none'
          showError('Enter a valid discount code');
        }
      } catch (err) {
        console.error(err);
        showError('Something went wrong applying the code');
      }
    };
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCartDiscountForm();

  // Robust observer for any section replacement containing the discount form
  const globalObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Check if the added node itself contains the discount form
            if (node.querySelector && node.querySelector('#cart-discount-form')) {
              initCartDiscountForm();
            }
            // Or if the node IS the discount form
            if (node.id === 'cart-discount-form') {
              initCartDiscountForm();
            }
          }
        });
      }
    }
  });
  globalObserver.observe(document, { childList: true, subtree: true });
});
